import gql from 'graphql-tag';

/**
 * Mutation for updating DSP settings on a line item
 * Used in the Campaign Order Queue Review page DSP Settings tab
 */
const UPDATE_LINE_ITEM_DSP_SETTINGS = gql`
  mutation updateLineItemDspSettings($lineItemId: ID!, $data: LineItemUpdateInput!) {
    updateLineItem(where: { id: $lineItemId }, data: $data) {
      id
      name
      supplySidePlatform
      maxBid
      frequencyCap
      dspLineItemId

      # Flight schedules
      flightSchedules {
        id
        startDate
        endDate
        budget
        cpm
        createdAt
        updatedAt
      }

      # Beacons for conversion tracking
      beacons {
        id
        beaconId
        name
        beaconType
      }

      # Inventory configuration
      inventorySources {
        id
        sourceId
        name
      }
      inventoryLists {
        id
        listId
        name
        action
        inventoryUsage
      }
      dspDealIds {
        id
        dspInternalId
        dealId
        name
        cpmBid
      }

      # Nexxen segments
      segments {
        id
        segmentId
        name
        segmentType
        cost
      }

      # Status info
      status
      updatedAt
    }
  }
`;

export default UPDATE_LINE_ITEM_DSP_SETTINGS;
